// extracted by mini-css-extract-plugin
export var contact = "footer-module--contact--23394";
export var contactInfo = "footer-module--contactInfo--d121b";
export var footer = "footer-module--footer--02543";
export var harta = "footer-module--harta--92f73";
export var info = "footer-module--info--064a2";
export var link = "footer-module--link--89f6d";
export var nav = "footer-module--nav--c3642";